import {} from 'react-intl';
import { IntlFormatters } from '@formatjs/intl/src/types';
import { pick } from 'lodash';

import { capitalizeEvery } from 'lib/string';
import { filterDeletedValues, locationFull } from 'lib/utils';
import profileAgeMessages from '../../ProfileAge/messages';

export const getName = (profile: AH$Profile): string => profile?.name || profile?.nick || '';

export const getTitleProfile = (profile: AH$Profile): string => {
  const currentPositions = filterDeletedValues(profile?.currentPositions);
  const title =
    typeof profile?.displayTitle === 'string' ? profile.displayTitle : profile?.displayTitle?.title;

  if (title) {
    return title;
  }

  if (currentPositions.length > 0) {
    const data = currentPositions[0];
    const displayedPosition = data?.position ? capitalizeEvery(data.position) : '';
    const company = data?.short_name || data?.companyName || '';

    return [displayedPosition, company].join(' ');
  }

  return '';
};

export const getAge = ({
  profile,
  formatDate,
  formatMessage,
}: {
  formatDate: IntlFormatters['formatDate'];
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
}): string => {
  const { ageExact, age, birthYear, birthMonth, birthDay } = pick(profile, [
    'age',
    'ageExact',
    'birthYear',
    'birthMonth',
    'birthDay',
  ]);

  if (ageExact && birthYear && birthMonth && birthDay) {
    const dateValue = new Date(birthYear, birthMonth - 1, birthDay);

    return formatDate(dateValue, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  return formatMessage(profileAgeMessages.age, { age })
    .replaceAll(/\n/g, ' ')
    .replaceAll(/\s+/g, ' ');
};

export const getLocation = (profile: AH$Profile): string =>
  locationFull(filterDeletedValues(profile.location)[0]);

export const getGeneralInfo = (profile: AH$Profile): string => profile.displaySummary || '';
